import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { DATE_FORMAT } from 'src/app/shared/constants/input.constants';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';

import { IClientDTO } from 'src/app/shared/model/client.model';

import { BehaviorSubject } from 'rxjs';

// type EntityResponseType = HttpResponse<CertificateRequestDto>;
// type EntityArrayResponseType = HttpResponse<IPortMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class BrokerCertificateService {
    // private clientDto = new BehaviorSubject('');
    // getClientDto = this.clientDto.asObservable();

    // changeMessage(message: string) {
    //     this.clientDto.next(message);
    //   }
    clientDto: IClientDTO;
    policyCurrency: string;
    policyId:number;

}
